import { supabase } from "@/integrations/supabase/client";
import { cleanPayload } from "@pps/supabase/payload";

/**
 * Handles an SSO handshake URL from the Portal app.
 * Works on both native (appUrlOpen) and web (window.location on mount).
 *
 * @param url - Full URL containing /sso?handshake=<uuid>
 * @returns true if session was successfully established
 */
export async function handleSSOHandshake(url: string): Promise<boolean> {
  try {
    const parsed = new URL(url);
    if (!parsed.pathname.startsWith("/sso")) return false;

    const handshake = parsed.searchParams.get("handshake");
    if (!handshake) return false;

    // Exchange handshake for a one-time magic-link token via Edge Function
    const { data, error } = await supabase.functions.invoke("sso-exchange", {
      body: cleanPayload({ handshake }),
    });

    if (error || !data?.token_hash) return false;

    // Verify the token — this establishes a full Supabase session
    const { error: verifyError } = await supabase.auth.verifyOtp({
      token_hash: data.token_hash,
      type: "email",
    });

    return !verifyError;
  } catch {
    return false;
  }
}
